<template>
    <div
         :style="`
         padding-right:${bodypadding}px;
         padding-left:${bodypadding}px;
         padding-top:${d.padding}px;
         padding-bottom:${d.padding}px;
         text-align:${d.textAlign};
         font-size:${d.fontsize};
         overflow: wrap;
         font-weight:${d.fontweight}`">
        {{d.text}}
    </div>
</template>

<script>
  import{
    mapState
  } from 'vuex'
  export default {
    props:['d','active','bodypadding'],
    components: {},
    name: "BText",
    data() {
      return {
      }
    },
    computed:{
      ...mapState(['icons','org'])
    },
    methods:{

    }
  }
</script>

<style scoped>

</style>
